import React, { useContext } from 'react'
import AwesomeError from 'components/Common/AwesomeError'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import BodyText from 'components/Luxkit/Typography/BodyText'
import ContactContext from 'contexts/contactContext'
import TextButton from 'components/Luxkit/Button/TextButton'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

interface Props {
  className?: string;
  hasError?: boolean;
}

function OfferCalendarNotAvailableMessage(props: Props) {
  const { hasError, className } = props
  const currentContact = useContext(ContactContext)
  const dispatch = useOfferPageDispatch()

  const onViewPackagesClick = () => {
    dispatch({ type: OfferPageActions.toggleSubFilter, filter: 'room' })
  }

  return (
    <AwesomeError
      title={hasError ? 'Oh no, an error occurred' : 'No dates available'}
      className={className}
    >
      <VerticalSpacer gap={32}>
        <BodyText variant="large">
          {hasError && 'Our team are working on fixing it now.'}
          {!hasError && 'Unfortunately this room has sold out.'}
          {' '}
          Try selecting another room type or give our customer support team a call on{' '}
          <a
            href={`tel:${currentContact.local.number}`}
            rel="nofollow"
          >{currentContact.local.humanReadable}
          </a>.
        </BodyText>
        <TextButton kind="primary" onClick={onViewPackagesClick}>
          View other rooms
        </TextButton>
      </VerticalSpacer>
    </AwesomeError>
  )
}

export default React.memo(OfferCalendarNotAvailableMessage)
